import oauthAxios, { API_BASE, OAUTH_BASE } from "./oauthAxios";

// Same { data, error } shape as the other services, plus `status` so the
// consent page can tell 401 (re-login in place) from 4xx (protocol error) from
// 5xx/network (retryable). status 0 means no response ever arrived --
// network failure, CORS or timeout.
const call = async (fn) => {
  try {
    const res = await fn();
    return { data: res.data, error: null, status: res.status };
  } catch (error) {
    return { data: null, error, status: error?.response?.status ?? 0 };
  }
};

// POST {OAUTH_BASE}get-auth-code -- the Bearer token is attached by the
// request interceptor. The payload carries exactly the six documented keys,
// with `state` omitted entirely when the client sent none.
export const getAuthCode = (payload) =>
  call(() => oauthAxios.post(`${OAUTH_BASE}get-auth-code`, payload));

// Same endpoint and payload as auth.services.signinUser, but on the bare
// instance so a 401 from a wrong password cannot blow away the authorize flow.
export const oauthSigninUser = (data) =>
  call(() => oauthAxios.post(`${API_BASE}login`, data));

// Best-effort, used by switch-account. An expired token 401s here, which on
// the shared instance would hard-navigate to /Login mid-flow.
export const oauthLogout = () => call(() => oauthAxios.post(`${API_BASE}logout`));
